export const DEFAULT_MAKE_OFFER_ERROR_MESSAGE =
  'Something went wrong. Please wait a moment and try again. If the issue continues, contact support.';

export const MAKE_OFFER_ERROR_MESSAGES = [
  {
    pattern: /active transaction/i,
    message:
      'This vehicle has an transaction in progress. You can check back later, as not all transactions get finalized.',
  },
  {
    pattern: /seller info is null/i,
    message:
      'This listing is missing some required information about the seller. Please contact support for further assistance.',
  },
  {
    pattern: /vehicle not found/i,
    message: 'This vehicle is no longer available for offers. It may have been sold or removed by the seller.',
  },
  {
    pattern: /could not find listingid/i,
    message: 'This listing is no longer available. It may have been sold or removed by the seller.',
  },
  {
    pattern: /load failed/i,
    message:
      'Something went wrong loading this page. Please wait a moment and try again. If the issue continues, contact support.',
  },
  {
    pattern: /failed to fetch/i,
    message: "We're having trouble connecting right now. Please check your internet connection and try again.",
  },
  {
    pattern: /unexpected token|is not valid json/i,
    message:
      'Something went wrong on our end. Please wait a moment and try again. If the issue continues, contact support.',
  },
];
